export class Queue<T> {
  private readonly state = new Map<number, T>()
  private startIndex = 0
  /** Exclusive */
  private endIndex = 0

  /**
   * Pushes a value onto the end of the queue.
   */
  push(value: T): void {
    this.state.set(this.endIndex, value)
    this.endIndex++
  }

  /**
   * Removes the value at the head of the queue, if any.
   */
  shift(): void {
    if (this.startIndex < this.endIndex) {
      this.state.delete(this.startIndex)
      this.startIndex++
    }
  }

  /**
   * Returns the value at the head of the queue, or undefined if the queue is empty.
   */
  head(): T | undefined {
    return this.state.get(this.startIndex)
  }

  clear(): void {
    this.state.clear()
    this.startIndex = 0
    this.endIndex = 0
  }

  /**
   * Returns an array of all values in the queue.
   */
  values(): T[] {
    const ans: T[] = []
    for (let i = this.startIndex; i < this.endIndex; i++) {
      ans.push(this.state.get(i)!)
    }
    return ans
  }
}
